/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_DoubleInputs */

const en_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double (♪♪)`)
};

const fr_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double (♪♪)`)
};

const de_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppel (♪♪)`)
};

const it_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppio (♪♪)`)
};

const ru_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двойной (♪♪)`)
};

const es_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doble (♪♪)`)
};

const zh_cn2_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双 (♪♪)`)
};

const ja_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダブル（♪♪）`)
};

const hi_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डबल (♪♪)`)
};

const pt_pt2_music_notes_double = /** @type {(inputs: Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplo (♪♪)`)
};

/**
* | output |
* | --- |
* | "Double (♪♪)" |
*
* @param {Music_Notes_DoubleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_double = /** @type {((inputs?: Music_Notes_DoubleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_DoubleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_music_notes_double(inputs)
	if (locale === "de") return de_music_notes_double(inputs)
	if (locale === "it") return it_music_notes_double(inputs)
	if (locale === "ru") return ru_music_notes_double(inputs)
	if (locale === "es") return es_music_notes_double(inputs)
	if (locale === "zh-CN") return zh_cn2_music_notes_double(inputs)
	if (locale === "ja") return ja_music_notes_double(inputs)
	if (locale === "hi") return hi_music_notes_double(inputs)
	if (locale === "pt-PT") return pt_pt2_music_notes_double(inputs)
	return en_music_notes_double(inputs)
});